import React from "react";
import { PythonService } from "../../api/python";
import ExcelUploadPanel from "./ExcelUploadPanel";

const ID_COLUMN_HELP = `Formato del Excel:
- Fila 1: encabezado (ej. student_id)
- Fila 2 en adelante: un ID por fila en columna A`;

const UnblockAcademic = () => (
  <ExcelUploadPanel
    title="Desbloqueo académico masivo"
    description="Sube un Excel con IDs de estudiantes para cambiar academic = true → false en blockades."
    helpText={ID_COLUMN_HELP}
    submitLabel="Procesar desbloqueo"
    onSubmit={(file) => PythonService.unblockAcademic(file)}
  />
);

export default UnblockAcademic;
